// import "./blocks/testimonials/scripts.js";
import "./blocks/product-slider/scripts.js";
import "./blocks/carousel/scripts.js";
